<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { permissionMethods, permissionComputed } from "@/state/helpers";

export default {
  components: { Layout, PageHeader },
  data() {
    return {
      tableData: [],
      hover: true,
      title: "All User Permissions",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "date",
      sortDesc: true,
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          value: "id",
          text: "ID",
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "created_at",
          label: "Creation Date",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...permissionComputed,
  },
  methods: {
    ...permissionMethods,
    createNewPermission(event) {
      console.log(event);
    },
    editPermission(permissionID) {
      console.log(permissionID);
    },
    deletePermission(permissionID) {
      console.log(permissionID);
    },
  },
  mounted() {
    this.loadPermissions();
  },
};
</script>
    
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-button @click="createNewPermission">Create Permission</b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <span class="p-2">Show</span>
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                    <span class="p-2">entries</span>
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :hover="hover"
                :items="permissions"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
              >
                <template #table-colgroup="scope">
                  <col
                    v-for="field in scope.fields"
                    :key="field.key"
                    :style="{
                      width: field.key === 'created_at' ? '200px' : '',
                    }"
                  />
                </template>

                <template #cell(id)="data">
                  <span>{{ data.value }}</span>
                </template>

                <template #cell(created_at)="data">
                  {{ moment(data.item.created_at).format("YYYY-MM-DD") }}
                </template>

                <template #cell(actions)="data">
                  <div class="d-flex">
                    <b-button
                      class="m-1"
                      @click="editPermission(data.item.id)"
                      size="sm"
                      >Edit</b-button
                    >
                    <b-button
                      class="m-1"
                      @click="deletePermission(data.item.id)"
                      size="sm"
                      >Delete</b-button
                    >
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>